import React, { useEffect, useMemo, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { useNavigate } from "react-router-dom";

import ContentCard from "../../../components/misc/ContentCard";
import DatePicker from "../../../components/misc/DatePicker";
import moment from "moment";
import FormButtons from "../../../components/misc/FormButtons";
import { fetchDownloadTemperatureChart } from "../../../redux/api/raports.api";
import {
  checkEndpointStatus,
  endpointStatus,
} from "../../../helpers/apiHelper";
import { dateForDatabase } from "../../../utils/dateAndTime";
import { fetchFleet } from "../../../redux/api/fleet.api";
import Dropdown, { DropdownValue } from "../../../components/misc/Dropdown";

function VehicleTemperatureChart() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const {
    fleet: {
      fleetData: {
        data: { data: fleetData },
      },
    },
  } = useAppSelector((state) => ({
    fleet: state.fleet,
  }));

  useEffect(() => {
    dispatch(
      fetchFleet({
        perPage: 10000,
      }),
    );
  }, [dispatch]);

  const yesterday = moment().subtract(1, "days").format("YYYY-MM-DD");

  const [isLoading, setIsLoading] = useState(false);
  const [transportDay, setTransportDay] = useState<Date | null>(
    new Date(yesterday),
  );
  const [selectedCar, setSelectedCar] = useState<DropdownValue | null>(null);

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleDownloadTemperatureChart = async () => {
    if (!selectedCar?.id) {
      return;
    }

    setIsLoading(true);

    const resultAction = await dispatch(
      fetchDownloadTemperatureChart({
        nrAuto: selectedCar?.label.toString().toUpperCase(),
        dataCursa: dateForDatabase(transportDay),
      }),
    );

    if (
      checkEndpointStatus(resultAction, fetchDownloadTemperatureChart) !==
      endpointStatus.pending
    ) {
      setIsLoading(false);
    }

    if (
      checkEndpointStatus(resultAction, fetchDownloadTemperatureChart) ===
      endpointStatus.fulfilled
    ) {
      setSelectedCar(null);
    }
  };

  const fleetNomenclaturesDropdownValues = useMemo(
    () =>
      fleetData?.map((item) => ({
        label: item.nrauto,
        id: item.id_auto,
      })),
    [fleetData],
  );

  const validNrAuto = selectedCar?.label?.toString().length;

  const disableSubmit =
    (validNrAuto && (validNrAuto < 6 || validNrAuto > 8)) ||
    !selectedCar?.label;

  return (
    <ContentCard
      cardTitle={"Descarca diagrama de temperatura pentru un autovehicul"}
      cardHeaderClassName="text-center"
      isLoading={isLoading}>
      <div>
        <Dropdown
          className="my-4"
          title={"Selecteaza masina"}
          data={fleetNomenclaturesDropdownValues}
          singleValue={selectedCar}
          setSingleValue={(value) => setSelectedCar(value)}
        />

        <DatePicker
          label="Data incepere"
          maxDate={new Date(yesterday)}
          value={transportDay}
          handleChangeDate={(value) => setTransportDay(value)}
        />
      </div>

      <FormButtons
        goBackLabel="Inapoi"
        goNextLabel="Descarca diagrama"
        nextButtonDisabled={disableSubmit}
        handleGoBack={handleGoBack}
        handleGoNext={handleDownloadTemperatureChart}
      />
    </ContentCard>
  );
}

export default VehicleTemperatureChart;
